import GlobalInstanceManager from "instance-manger";
import { useState, useEffect, useCallback } from "react";
import { io } from "socket.io-client";

interface Message {
  data: string;
}
const socketRef: any = {
  current: null,
};
export const useWebSocket = () => {
  const [messages, setMessages] = useState<Message[]>([]);
  const [isOpen, setIsOpen] = useState(false);

  const url = GlobalInstanceManager.webcomponentProps.apiUrl;
  const sendMessage = useCallback((event: string, payload: any) => {
    if (socketRef.current && socketRef.current.connected) {
      socketRef.current.emit(event, payload);
    }
  }, []);

  useEffect(() => {
    if (url && !socketRef.current) {
      socketRef.current = io(`${url}/`);
      socketRef.current.on("connect", () => {
        // eslint-disable-next-line no-console
        console.log("connected");
        setIsOpen(true);
      });
      socketRef.current.on("disconnect", () => {
        setIsOpen(false);
      });

      socketRef.current.on("message", (data: string) => {
        const newMessage = { data };
        setMessages((prevMessages) => [...prevMessages, newMessage]);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url]);

  const getEvent = socketRef.current;

  return { messages, sendMessage, isOpen, getEvent };
};
